import { arrowDown } from "helper/icons";
import { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { CheckBox } from "shared/Components/checkbox";

const MultiSelectDropdown = (props) => {
  const {
    dropdownOptions,
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    placeholder,
    showIconLeft = false,
    checkValidation,
    onChange,
    label,
    errorMsg,
    disabled = false,
    isFaded,
    dynamicHeight = false,
    className = "",
    customContent,
  } = props || {};
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({});
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsOpen((prev) => !prev);
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  };

  const onSelectOption = (option, selectIndex) => {
    const tempOptionArray = dropdownOptions.map((d, index) => {
      if (selectIndex === index) {
        return { ...d, isSelected: !d.isSelected };
      }
      return d;
    });
    onChange?.(tempOptionArray);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      {!!label && (
        <div className="mb-0.5">
          <span className="text-gray-700 font-medium text-sm">{label}</span>
        </div>
      )}
      <button
        type="button"
        ref={buttonRef}
        className={`${width} flex ${checkValidation ? "border-red" : ""}
          ${showIconLeft ? "flex-row-reverse" : "flex-row"} ${
          showIconLeft ? "justify-end" : "justify-between"
        }
          items-center rounded-lg border border-gray-300 shadow-sm px-2.5 py-2.5  ${
            isFaded ? "bg-white" : "bg-white"
          }
          text-base font-regular text-gray-500 inputFocus focus:outline-none ${customContent} ${className}`}
        onClick={toggleDropdown}
        disabled={disabled}
      >
        <span className="text-gray opacity-[0.7] overflow-hidden whitespace-nowrap text-ellipsis">
          {placeholder}
        </span>
        {!disabled && (
          <img
            src={arrowDown}
            height={20}
            width={20}
            alt=""
            className={`transform transition-transform duration-200 ${isOpen ? "rotate-0" : "rotate-180"} ${showIconLeft ? "mr-[5px]" : ""}`}
          />
        )}
      </button>
      {isOpen &&
        createPortal(
          <div
            ref={dropdownRef}
            className={`absolute rounded-lg shadow-lg bg-white z-50 overflow-y-scroll ${
              !dynamicHeight ? "max-h-[185px]" : ""
            }`}
            style={{
              position: "absolute",
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              width: dropdownPosition.width,
            }}
          >
            <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
              {dropdownOptions.map((option, index) => (
                <button
                  key={option.id}
                  onClick={(event) => {
                    event.stopPropagation();
                    onSelectOption(option, index);
                  }}
                  className={`w-full text-left px-4 py-4 text-sm text-gray-700 hover:bg-primary/50 hover:text-white flex ${
                    index !== dropdownOptions?.length - 1 ? "border-b" : ""
                  } border-gray-200`}
                  role="menuitem"
                >
                  <CheckBox isChecked={option.isSelected} />
                  {option.title}
                </button>
              ))}
            </div>
          </div>,
          document.body
        )}
      {!!errorMsg && (
        <span className="text-red font-medium text-sm mt-1 pt-2">
          {errorMsg}
        </span>
      )}
    </div>
  );
};

export default MultiSelectDropdown;